import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import { useEffect, useState } from "react";
import { renderSnackbarNotificationHiddenItems } from "../../../use-cases/render-snackbar-reminder-hidden-items";

export const useFilterViewOurNodeInitialHook = () => {
  const initialStructureNodeset = getInitialStructureNodeset();

  const [flatArray, setFlatArray] = useState(
    Array.from(initialStructureNodeset.getFilteredFlatMap().values()),
  );

  const [hiddenCount, setHiddenCount] = useState(0);

  useEffect(() => {
    const calculateHiddenSelectedCount = () => {
      initialStructureNodeset.calculateSelectedHiddenNodesSet();

      setHiddenCount(initialStructureNodeset.getSelectedHiddenNodesSet().size);

      if (initialStructureNodeset.getSelectedHiddenNodesSet().size > 0) {
        renderSnackbarNotificationHiddenItems();
      }
    };

    calculateHiddenSelectedCount();
  }, [initialStructureNodeset.getFlatMap()]);

  useEffect(() => {
    const updateFlatMap = () => {
      const newFlatMap = initialStructureNodeset.getFilteredFlatMap();
      setFlatArray(Array.from(newFlatMap.values()));
    };

    initialStructureNodeset.addObserver(updateFlatMap);

    return () => {
      initialStructureNodeset.removeObserver(updateFlatMap);
    };
  }, [initialStructureNodeset]);

  return {
    hiddenCount,
    data: Array.from(initialStructureNodeset.getFilteredFlatMap().values()),
  };
};
